import { cn } from '@utils/index'

const COLOR = 'hsl(183 100% 74%)'

export function AirclawLogo({ className }: { className?: string }) {
  return (
    <svg
      className={cn('w-10 h-8', className)}
      width="105"
      height="88"
      viewBox="0 0 105 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41.2859 0.561027H63.498L52.3919 87.5446L41.2859 0.561027Z"
        fill={COLOR}
      />
      <path
        d="M0.74585 0.561005H22.9579L41.7466 87.5446L0.74585 0.561005Z"
        fill={COLOR}
      />
      <path
        d="M82.2867 0.561027H104.499L63.498 87.5446L82.2867 0.561027Z"
        fill={COLOR}
      />
    </svg>
  )
}
